import Route from 'cio/routes/base';

export default class EditRoute extends Route {
  crumb() {
    return {
      name: 'Edit',
      path: 'draft.edit',
    };
  }

  afterModel(model) {
    return model.belongsTo('detail').load();
  }
}
